import axios from "axios";
import { useEffect, useState } from "react";

import { IExpenditureInHandlerProduction } from "pages/Handler/ui/ProHandler/components/Body/components/Expenditures/types";

import { generateStorageKey } from "utils/helpers/generateStorageKey";

interface IProps {
  isInfo: boolean;
  relationOriginInfo: IExpenditureInHandlerProduction | null;
  objectId: number;
}

export const useBuildingMatchingProductInfo = ({ isInfo, objectId, relationOriginInfo }: IProps) => {
  const [isLoaidng, setIsLoading] = useState<Record<string, boolean>>({});
  const [data, setData] = useState<Record<string, any>>({});
  const key = generateStorageKey({ objectId, id: relationOriginInfo?.id });

  useEffect(() => {
    if (!isInfo || !relationOriginInfo) return;
    if (!data[key]) {
      setIsLoading((prev) => ({ ...prev, [key]: true }));
    }
    const url = relationOriginInfo.is_default
      ? //@ts-expect-error
        `/building/${objectId}/estimate/expenditure/${relationOriginInfo.estimate_expenditures[0]}/`
      : `/building/${objectId}/estimate/expenditure/${relationOriginInfo.id}/`;
    axios
      .get(url)
      .then(({ data }) => {
        setData((prev) => ({ ...prev, [key]: data }));
      })
      .finally(() => {
        setIsLoading((prev) => ({ ...prev, [key]: false }));
      });
  }, [isInfo, objectId]);

  return { isLoaidng: isLoaidng[key], data: data[key] };
};
